export default {

  // userLocation: {
  //   lat: '',
  //   lng: '',
  // },
  userLocation: null,
  game: null,

  errorMessage: '',
  isUserAtChallengeLocation: {
    isUserInOneZone: null,
    challengeId: null,
  },
  challengesLocations: [],
  drawerState: false,
  fingerprint: '',

  team: null,
  mapZoom: null,
  mapCenter: null,

  userScore: 0,
  questionRadius: 80,

  launchTutorial: false,
  tutorialInProgress: false,

  apiKey: null,
  isLoggedIn: false,

  config: null,
  tenant: null,
}



// WEBPACK FOOTER //
// ./src/store/state.js